import { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDebounce } from 'react-use';

const ROW_SETTLE_DEBOUNCE_MS = 200;

export const useRowSettle = () => {
  const [settled, setSettled] = useState(false);

  const { ref, inView } = useInView();

  useDebounce(
    () => {
      if (inView) setSettled(true);
    },
    ROW_SETTLE_DEBOUNCE_MS,
    [inView],
  );

  return { settled, ref };
};
